import Expenses from './ExpenseManagement/Expenses';

export default Expenses;
